import localStorage from "redux-persist/lib/storage";
import initPlayers from "../context/player-list-context/initPlayers";

export const persistConfig = {
  storage: localStorage,
  key: "root",
  transforms: [initPlayers]
};
